
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import ArticleInfoCover from '@root/modules/article/components/info/ArticleInfoCover.vue';
import { faCalendarDay } from '@delfi.lt/fa-kit/icons/modules/classic/regular';

interface Props {
  article: ArticleData;
}
interface Computed {
  title: string;
  subtitle: string;
  isAdultArticle: boolean;
  isAdultConfirmed: boolean;
}
export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    ArticleInfoCover,
  },
  props: {
    article: {
      required: true,
    },
  },
  data() {
    return {
      faCalendarDay,
    };
  },
  computed: {
    title() {
      return this.article.content.title.html.replace(/(<\/?h1>)/gi, '');
    },
    subtitle() {
      return this.article.content.subtitle.text || String(this.$t('words.live'));
    },
    isAdultArticle() {
      return this.article.settings['icon.adult'] || this.article.settings['articleAdultContent'] || false;
    },
    isAdultConfirmed() {
      return this.$store.state.article.isAdultConfirmed;
    },
  },
});
